<!-- See bar-chart.component.html: group, not img — this svg holds controls
     only when something is actually listening for a selection (see
     hasSelectListener); otherwise the dots are inert and this is decorative. -->
<svg class="chart-svg" [attr.viewBox]="'0 0 ' + viewW + ' ' + viewH" role="group"
     [attr.aria-label]="ariaLabel">

  <path class="area" *ngIf="areaFill && layout.coords.length > 1" [attr.d]="layout.areaD"/>
  <path class="stroke compare" *ngIf="compareLayout.d" [attr.d]="compareLayout.d" fill="none"/>
  <path class="stroke" *ngIf="layout.d" [attr.d]="layout.d" fill="none"/>

  <circle *ngFor="let c of layout.coords; trackBy: trackCoord"
          class="chart-hit dot"
          [attr.cx]="c.x" [attr.cy]="c.y" r="2.5"
          [attr.tabindex]="hasSelectListener ? 0 : null"
          [attr.role]="hasSelectListener ? 'button' : null"
          [attr.aria-label]="c.label + ' ' + (displayValues[c.index] ?? c.value)"
          (click)="onSelect(c)"
          (keydown.enter)="onSelect(c, $event)"
          (keydown.space)="onSelect(c, $event)"/>
</svg>

<table class="chart-data">
  <caption>{{ ariaLabel }}</caption>
  <thead *ngIf="hasCompare">
    <tr><td></td><th scope="col">{{ ariaLabel }}</th><th scope="col">{{ compareLabel }}</th></tr>
  </thead>
  <tbody>
    <tr *ngFor="let c of layout.coords; trackBy: trackCoord">
      <th scope="row">{{ c.label }}</th>
      <td>{{ displayValues[c.index] ?? c.value }}</td>
      <td *ngIf="hasCompare">{{ compareDisplayValues[c.index] ?? '' }}</td>
    </tr>
  </tbody>
</table>
